/* @flow */

import ReactMarkdown from 'react-markdown';
import { Link } from 'react-router-dom';
import { compose } from 'ramda';
import * as React from 'react';
import { hasURLProtocol } from '@e180/util/lib/url';

import useEventAccentColor from 'src/shared/domain/event/hook/useEventAccentColor';

type Props = {
  children: string,
};

const Markdown = ({ children }: Props): React.Node => {
  /*
   |----------------------------------------------------------------------------
   | Hooks
   |----------------------------------------------------------------------------
   */

  // @TODO: should be done in the parent component on a case-by-case basis
  const [accentColor] = useEventAccentColor();

  const strongRenderer = (props) => (
    <strong style={{ color: accentColor }} {...props} />
  );

  /*
   |----------------------------------------------------------------------------
   | Elements
   |----------------------------------------------------------------------------
   */

  const linkRenderer = (props) =>
    hasURLProtocol(props.href) ? (
      <a rel="noopener noreferrer" target="_blank" {...props} />
    ) : (
      <Link to={props.href} {...props} />
    );

  return (
    <ReactMarkdown
      source={children}
      renderers={{
        strong: strongRenderer,
        link: linkRenderer,
      }}
    />
  );
};

export default compose(React.memo)(Markdown);
